import { Injectable } from '@angular/core';

import { FeatureService } from './feature.service';
import { LaunchDarklyService } from './launch-darkly.service';
import { AppSettingsService } from '../../../../core/services/app-settings/app-settings.service';
import { ToggleFeatureKeys } from '../enums/toggle-feature-keys.enum';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  constructor(
    private featureService: FeatureService,
    private launchDarklyService: LaunchDarklyService,
    private appSettingsService: AppSettingsService
  ) { }

  public initialize(): Promise<void> {
    return this.launchDarklyService
      .initialize(
        this.appSettingsService.configuration.launchDarkly.apiKey,
        this.appSettingsService.configuration.launchDarkly.isEnabled,
        {
          key: 'anon',
          anonymous: true
        }
      )
      .then(() => {
        Object.keys(ToggleFeatureKeys).forEach((featureKey) => {
          const featureName = ToggleFeatureKeys[featureKey];
          const featureValue = this.launchDarklyService.getFlag(featureName);
          this.featureService.updateFeature(featureName, featureValue);
        });

        this.launchDarklyService.featureValueChanged.subscribe((feature) => {
          if (feature) {
            const featureValue = this.launchDarklyService.getFlag(feature.name);
            this.featureService.updateFeature(feature.name, featureValue);
          }
        });
      });
  }

  public changeUser(user): void {
    if (user !== 'Anonymous') {
      this.launchDarklyService.identify({
        key: user.email,
        name: user.name,
        email: user.email,
        anonymous: false
      });
    } else {
      this.launchDarklyService.identify({ key: 'anon', anonymous: true });
    }
  }
}
